const initialState = {
  projects: { data: { data: [], pagination: {} } },
  selectedProject: { data: null }
};

const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_PROJECTS':
      return {
        ...state,
        projects: { data: action.data }
      };
    
    case 'GET_PROJECT_BY_ID':
      return {
        ...state,
        selectedProject: { data: action.data }
      };
    
    case 'PROJECT_LOADING':
      return {
        ...state,
        loading: true,
        error: null
      }
    
    case 'PROJECT_ERROR':
      return {
        ...state,
        loading: false,
        error: action.error
      }
    
    case 'CLEAR_PROJECT_DATA':
      return {
        ...state,
        selectedProject: { data: null },
        error: null
      }
    
    default:
      return state;
  }
};

export default projectReducer; 